import { LANGUAGE_RECEIVE_LANGUAGES, LANGUAGE_CURRENT_CLASSNAME, LANGUAGE_RECEIVE_DICTIONARIES, LANGUAGE_CURRENT } from '../../constants';

export const language = (state = { menu: [] }, action) => {
    switch (action.type) {
        case LANGUAGE_CURRENT:
        case LANGUAGE_CURRENT_CLASSNAME:
        case LANGUAGE_RECEIVE_DICTIONARIES:
        case LANGUAGE_RECEIVE_LANGUAGES:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
